// ONE class string for every consent action button (banner and modal).
//
// Accept, reject and customise are deliberately styled by the same constant:
// equal visual weight is a legal requirement (CNIL, AEPD, EDPB cookie-banner
// taskforce), not a taste. Do not give one of them a different colour, size or
// emphasis, and do not turn "reject" into a text link.
//
// `rounded-none!` and `font-semibold!` are important on purpose: the global
// stylesheets are UNLAYERED (assets/elements.css `button { @apply rounded-full }`,
// assets/base.css `* { font-weight: normal }`), so they beat Tailwind's layered
// utilities. Without `!` the bar's inner edges turn into pills and every weight
// utility in this folder is silently ignored.
export const CONSENT_ACTION_CLASS =
  // cursor-pointer: Tailwind 4 resets <button> to the default arrow cursor.
  'min-h-[44px] cursor-pointer rounded-none! px-2 py-3 text-sm font-semibold! leading-tight text-white text-center ' +
  'bg-smartway-blue hover:bg-[#1a1699] ' +
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-white'

/** The segmented bar holding the three actions. */
export const CONSENT_ACTION_BAR_CLASS = 'grid grid-cols-3 divide-x divide-white/40 bg-smartway-blue'

// The banner covers the bottom of the page. While it shows, it publishes its height here (on <html>)
// and the scroll containers - PublicLayout, AppLayout - pad their bottom edge by it, so everything
// can be scrolled above the bar instead of staying stuck underneath it.
export const BANNER_HEIGHT_VAR = '--tpa-cookie-banner-h'
export const BANNER_CLEARANCE = `var(${BANNER_HEIGHT_VAR}, 0px)`
